
/* eslint-disable no-unused-vars */
import GacToThreeJsTools from './GacToThreeJsTools'
import Utils from './utils'
const THREE = window.THREE
class Viewer {
  constructor() {
    this._controls
    this._renderer
    this._scene
    this._camera
    this._objectInScene
    this._refresher
    this._mount
    this._sceneChildren = []
  }

  init(id) {
    if (this._mount != null) {
      return
    }
    this._mount = document.getElementById(id)
    if (this._mount === null) {
      this._mount = document.createElement('div')
      this._mount.id = 'GouJianWuViewer'
      this._mount.style = 'width:1000px; height:600px'
      document.body.append(this._mount)
    }

    this._initRender() // render
    this._initScene()
    this._initCamera() // camera
    this._initLight()

    if (this._mount.firstChild) {
      this._mount.removeChild(this._mount.firstChild)
    }

    this._mount.appendChild(this._renderer.domElement)
    this._initControls() // append dom
    this._animate()
  }

  async loadGacJson(gacJson, showDimension) {
    this.clear()
    const loader = new THREE.ObjectLoader()
    const obj = await GacToThreeJsTools.convertGacJsonToThressJson(gacJson, showDimension)
    loader.parse(obj, (data) => {
      this._objectInScene = null
      this._objectInScene = data
      this._sceneChildren.push(this._objectInScene)
      this._setContentCenter(this._objectInScene)
      this._scene.add(this._objectInScene)
      if (gacJson.nodes) {
        gacJson.nodes.forEach((n) => {
          if (n.type === 'dimension' && n.children && showDimension) {
            n.children.forEach((cn) => {
              this.setNodeType(cn)
            })
          }
          // setNodeType(n)
        })
      }
    })
  }

  loaderByUrl(url) {
    const loader = new window.THREE.ObjectLoader()
    // let url = "https://gahu-partnerapi.magicloud.cn/api/b8d3e38c-b038-4b98-88a2-9364f3e6a45d/EquJson?L=600&W=890&H=600"
    loader.load(url, (obj) => {
      this._objectInScene = obj

      this._scene.add(obj)
      this.__animate()
    })
  }

  loaderByJson(obj) {
    const loader = new THREE.ObjectLoader()
    // let obj = getThreeJsJsonDemo()

    this._objectInScene = loader.parse(obj)
    this._scene.add(this._objectInScene)
    this._animate()
  }

  setNodeType(node) {
    const n = node
    if (!n.color) {
      n.color = [255, 1, 255]
    }
    if (n.type === 'line') {
      const material = new THREE.LineBasicMaterial({ color: Utils.rgbaToHex(...n.color) })
      const points = []
      points.push(new THREE.Vector3(...n.startPoint))
      points.push(new THREE.Vector3(...n.endPoint))
      const geometry = new THREE.BufferGeometry().setFromPoints(points)
      const line = new THREE.Line(geometry, material)
      this._scene.add(line)
      this._sceneChildren.push(line)
    } else if (n.type === 'arc') {
      const material = new THREE.LineBasicMaterial({ color: Utils.rgbaToHex(...n.color) })
      const arc = new THREE.ArcCurve(
        0, 0,
        n.radius,
        n.startAngle, n.endAngle,
        n.antiClockwise
      )
      const points = arc.getPoints(50)
      const geometry = new THREE.Geometry()
      points.forEach(function(v) {
        geometry.vertices.push(new THREE.Vector3(v.x, v.y, 0))
      })
      const line = new THREE.Line(geometry, material)
      line.position.set(...n.coordinate.origin) // 设置相对位置

      const xOld = new THREE.Vector3(1, 0, 0)
      const xNew = new THREE.Vector3(n.coordinate.x[0] - n.coordinate.origin[0], n.coordinate.x[1] - n.coordinate.origin[1], n.coordinate.x[2] - n.coordinate.origin[2])
      line.rotation.x = xOld.angleTo(xNew)

      const yOld = new THREE.Vector3(0, 1, 0)
      const yNew = new THREE.Vector3(n.coordinate.y[0] - n.coordinate.origin[0], n.coordinate.y[1] - n.coordinate.origin[1], n.coordinate.y[2] - n.coordinate.origin[2])
      line.rotation.y = yOld.angleTo(yNew)

      // let zOld = new THREE.Vector3(0,0,1);
      // let zNew = new THREE.Vector3(n.coordinate.origin[0],n.coordinate.origin[1] ,n.coordinate.origin[2]);
      // line.rotation.z = zOld.angleTo(zNew)

      // line.rotation.y = 90 * Math.PI / 180;
      this._scene.add(line)
      this._sceneChildren.push(line)
    } else if (n.type === 'ellipse') {
      const material = new THREE.LineBasicMaterial({ color: Utils.rgbaToHex(...n.color) })
      const ellipse = new THREE.EllipseCurve(
        n.coordinate.x, n.coordinate.y,
        n.majorRadius, n.minorRadius,
        n.startAngle, n.endAngle,
        n.antiClockwise)
      const ellipsePath = new THREE.CurvePath()
      ellipsePath.add(ellipse)
      const ellipseGeometry = ellipsePath.createPointsGeometry(100)
      ellipseGeometry.computeTangents()
      const line = new THREE.Line(ellipseGeometry, material)
      this._scene.add(line)
      this._sceneChildren.push(line)
    } else if (n.type === 'edge') {
      const geometry = new THREE.Geometry()
      Utils.arrGroup(n.vertices, 3).forEach((points) => {
        geometry.vertices.push(new THREE.Vector3(points[0], points[1], points[2]))
      })
      const edges = new THREE.EdgesGeometry(geometry)
      const line = new THREE.LineSegments(edges, new THREE.LineBasicMaterial({ color: Utils.rgbaToHex(...n.color) }))
      this._scene.add(line)
    }
  }

  _setContentCenter(object) {
    const box = new THREE.Box3().setFromObject(object)
    const size = box.getSize(new THREE.Vector3())
    const center = box.getCenter(new THREE.Vector3())
    const fitOffset = 1.2
    const maxSize = Math.max(size.x, size.y, size.z)
    const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * this._camera.fov) / 360))
    const fitWidthDistance = fitHeightDistance / this._camera.aspect
    const distance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance)
    const direction = this._controls.target
      .clone()
      .sub(this._camera.position)
      .normalize()
      .multiplyScalar(distance)
    this._controls.maxDistance = distance * 10
    this._controls.target.copy(center)
    this._camera.near = distance / 100
    this._camera.far = distance * 100
    this._camera.updateProjectionMatrix()
    this._camera.position.copy(this._controls.target).sub(direction)
  }

  _initLight() {
    const scene = this._scene

    // V1
    // this._scene.add(new THREE.AmbientLight(0x505050));

    // let spotLight = new THREE.SpotLight(0xffffff,0.8);
    // spotLight.position.set(1000, 10000, 1000);
    // spotLight.castShadow = true;
    // spotLight.shadow.mapSize.width = 1024;
    // spotLight.shadow.mapSize.height = 1024;

    // spotLight.shadow.camera.near = 500;
    // spotLight.shadow.camera.far = 4000;
    // spotLight.shadow.camera.fov = 30;
    // this._scene.add(spotLight); // camera

    // V2
    this._scene.add(new THREE.AmbientLight(0x808080))
    const rLight = new THREE.SpotLight(0x808080, 0.8)
    rLight.position.set(5000, 5000, 2000)
    this._scene.add(rLight)

    var llight = new THREE.SpotLight(0x808080, 0.8)
    llight.position.set(-5000, -5000, 2000)
    this._scene.add(llight)

    var downLight = new THREE.SpotLight(0xffffff, 0.8)
    downLight.position.set(0, 0, -10000)
    this._scene.add(downLight)

    var upLight = new THREE.SpotLight(0xffffff, 0.8)
    upLight.position.set(0, 0, 10000)
    this._scene.add(upLight)
  }

  _initScene() {
    this._scene = new THREE.Scene() // light
  }

  _initRender() {
    // bgColor = '#f1f1f1';
    let width = this._mount.clientWidth
    let height = this._mount.clientHeight
    if (width === 0) {
      // eslint-disable-next-line no-console
      console.error('width is 0')
      width = 700
    }
    if (height === 0) {
      // eslint-disable-next-line no-console
      console.error('height is 0')
      height = 600
    }
    this._renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true
    })
    // renderer.setClearColor(bgColor);
    this._renderer.setClearColor(0xEEEEEE, 0.0)
    this._renderer.setSize(width, height)
    this._renderer.setPixelRatio(window.devicePixelRatio)
    this._renderer.sortObjects = false
  }

  _animate() {
    // 更新控制器
    this._render()
    // 更新性能插件
    this._controls.update()
    requestAnimationFrame(() => { this._animate() })
  }

  _initControls() {
    this._controls = new THREE.OrbitControls(this._camera, this._renderer.domElement)
    // this._controls.autoRotate = true;
    this._controls.rotateSpeed = 2
    this._controls.autoRotateSpeed = 0.5
    this._controls.minZoom = 0.5
    this._controls.maxZoom = 2
    this._controls.zoomSpeed = 1.0
    this._controls.panSpeed = 1.5
    this._controls.enableZoom = true
    this._controls.enablePan = true
    this._controls.enableDamping = true
    this._controls.dampingFactor = 0.3
    this._controls.enabled = true
  }

  _initCamera() {
    const width = this._mount.clientWidth
    const height = this._mount.clientHeight
    const cameraAspect = width / height
    // camera = new THREE.PerspectiveCamera(70, cameraAspect, 1, 100000);
    this._camera = new THREE.PerspectiveCamera(45, cameraAspect, 0.1, 1000)
    this._camera.name = 'Camera'
    this._camera.position.set(600, 1000, 600)
    this._camera.up.x = 0// 相机以哪个方向为上方
    this._camera.up.y = 0
    this._camera.up.z = 1
    this._camera.lookAt(new THREE.Vector3(0, 0, 0))
    // camera.lookAt(scene.position);
  }

  _render() {
    this._renderer.render(this._scene, this._camera)
  }

  clear(option) {
    this._sceneChildren.forEach((c) => {
      if (c instanceof THREE.Mesh) {
        c.geometry.dispose()
        c.material.dispose()
      }
      this._scene.remove(c)
    })
    this.removeCube()

    if (option && option.clearMount && this._mount) {
      this.clearRenderer()
      if (this._mount.firstChild) {
        this._mount.removeChild(this._mount.firstChild)
      }

      this._mount = null
    }

    clearInterval(this._refresher)
  }

  clearRenderer() {
    let renderer = this._renderer
    if (!renderer) {
      return
    }
    renderer.dispose()
    renderer.forceContextLoss()
    renderer.context = null
    renderer.domElement = null
    renderer = null
  }

  removeCube() {
    const _scene = this._scene
    let _objectInScene = this._objectInScene
    if (!_objectInScene) {
      return
    }
    var allChildren = _objectInScene.children.filter((x) => x)
    allChildren.forEach((c) => {
      if (c instanceof THREE.Mesh) {
        this.dispose(_scene, c)
        this.dispose(_objectInScene, c)
      }
    })
    _objectInScene = null
  }

  dispose(parent, child) {
    if (child.children.length) {
      const arr = child.children.filter((x) => x)
      arr.forEach((a) => {
        this.dispose(child, a)
      })
    }
    if (child instanceof THREE.Mesh || child instanceof THREE.Line) {
      if (child.material.map) child.material.map.dispose()
      child.material.dispose()
      child.geometry.dispose()
    } else if (child.material) {
      child.material.dispose()
    }
    child.remove()
    parent.remove(child)
  }
}

export { Viewer }
